<template>
  <v-container>
    <v-dialog v-model="alert.type" max-width="390" transition="scale-transition">
      <v-card>
        <v-card-title :class="alert.color">
          {{ alert.title }}
        </v-card-title>

        <v-card-text>
          {{ alert.message }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="alert.type = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="!isDetails">
      <template cols="6" sm="12" md="6">
        <v-data-table :headers="headers" :items="mode" class="elevation-3" :search="search">
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small @click="viewDetails(item)">View details </v-btn>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize"> Reset </v-btn>
          </template>
        </v-data-table>
      </template>
    </div>

    <div v-if="isDetails">
      <v-btn class="ma-2" color="primary" @click="isDetails = false">
        Go Back
      </v-btn>

      <template cols="6" sm="12" md="6">
        <v-data-table :headers="headers1" :items="details" class="elevation-3" :search="search">
          <template v-slot:no-data>
            <v-btn color="primary" @click="isDetails = false"> Go Back </v-btn>
          </template>
          <template v-slot:[`item.next_visit`]="{ item }">
            {{ formatDate(item.next_visit) }}
          </template>
          <template v-slot:[`item.last_visit`]="{ item }">
            {{ formatDate(item.last_visit) }}
          </template>
        </v-data-table>
      </template>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    elapse: null,
    alert: {
      color: "info",
      title: null,
      message: null,
      type: null,
    },
    valid: true,
    dialog: false,
    menu2: false,
    menu3: false,
    dialogDelete: false,
    expanded: [],
    singleExpand: true,
    isDetails: false,
    details: [],
    search: "",
    headers: [
      { text: "Staff", value: "user_name" },
      { text: "Missing count", value: "count" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headers1: [
      { text: "Field ID", value: "farm_id" },
      { text: "Missed visit", value: "next_visit" },
      { text: "Farmer id", value: "farmer_id" },
      { text: "Farmer", value: "farmer" },
      { text: "Last visit", value: "last_visit" },
    ],
    mode: [],
    editedIndex: -1,
    editedItem: {
      label: "",
      id: 0,
    },

    defaultItem: {
      label: "",
      id: 0,
    },

    nameRules: [(v) => !!v || "Mode is required", (v) => (v && v.length <= 100) || "Mode must be less than 100 characters"],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      axios
        .get("general-notification/staff-summary")
        .then((res) => {
          this.mode = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewDetails(item) {
      this.isDetails = true;
      this.details = item.details;
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },

    editItem(item) {
      this.editedIndex = this.mode.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.mode.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    getMax(arr, prop) {
      let max;
      for (var i = 0; i < arr.length; i++) {
        if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop])) max = arr[i];
      }
      return max;
    },
    deleteItemConfirm() {
      axios
        .delete("mode/" + this.editedItem.id)
        .then((res) => {
          if (res.code === 200) {
            // this.$swal(res.data.message);
            this.alert.color = "green--text";
            this.alert.title = "Success";
            this.alert.message = "Mode Deleted";
            this.alert.type = true;
            this.mode.splice(this.editedIndex, 1);
          }
        })
        .catch((err) => {
          // this.$swal("Sorry, There is an error : " + err.message);

          this.alert.color = "red--text";
          this.alert.title = "Error";
          this.alert.message = err.message;
          this.alert.type = true;
        })
        .finally(() => {
          this.alert.color = "green--text";
          this.alert.title = "Success";
          this.alert.message = "Mode Deleted";
          this.alert.type = true;
          this.mode.splice(this.editedIndex, 1);
          this.closeDelete();
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.reset();
      });
    },

    async closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    formatDate(date) {
      let monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      //  month = "" + (d.getMonth() + 1),
      var d = new Date(date),
        month = "" + monthNames[d.getMonth()],
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // var d = dateVar.add(-1).day().toString('dd-MMM-yyyy');

      return [day, month, year].join(" - ");
    },
    async save() {
      this.validate();
      this.editedItem.brand_id = this.editedItem.brand_id + "";
      this.editedItem.location_Id = this.editedItem.location_Id + "";

      if (this.editedIndex > -1) {
        await axios
          .patch("mode/" + this.editedItem.id, {
            label: this.editedItem.label,
          })
          .then((res) => {
            if (res.data) {
              this.alert.color = "green--text";
              this.alert.title = "Success";
              this.alert.message = res.data.message;
              this.alert.type = true;
              console.log(res.data);
              Object.assign(this.mode[this.editedIndex], this.editedItem);
            }
          })
          .catch((err) => {
            this.alert.color = "red--text";
            this.alert.title = "Error";
            this.alert.message = err.message;
            this.alert.type = true;
          })
          .finally(() => {
            this.close();
          });
      } else {
        if (this.editedItem.label === null || this.editedItem.label === "" || this.editedItem.label === undefined) {
          this.alert.color = "red--text";
          this.alert.title = "Error";
          this.alert.message = "Please fill Mode";
          this.alert.type = true;
        } else {
          let data = {
            label: this.editedItem.label,
          };
          await axios
            .post("mode", data)
            .then((res) => {
              if (res.data) {
                // this.$swal(res.data.message);

                this.alert.color = "green--text";
                this.alert.title = "Success";
                this.alert.message = "Mode " + res.statusText;
                this.alert.type = true;
                console.log("res");
                console.log(res);

                this.mode.push(res.data);
              }
            })
            .catch((err) => {
              this.alert.color = "red--text";
              this.alert.title = "Error";
              this.alert.message = err.message;
              this.alert.type = true;
              // this.$swal("Sorry, There is an error : " + err.message);
              console.log(err);
            })
            .finally(() => {
              this.close();
            });
        }
      }
    },
  },
};
</script>
<style>
.compact-form {
  transform: scale(0.865);
  transform-origin: center;
}
</style>
